/** The included SMS credits reset at 00:00 America/New_York on the 1st: that is the date every viewer must see. */
export const SMS_CREDIT_RESET_TIME_ZONE = 'America/New_York';

/**
 * Formats the reset instant in New York time (NOT the browser zone: a Pacific user would otherwise read Oct 31 for a Nov 1 reset)
 * with an "(ET)" hint. Returns null for a missing / unparsable value.
 */
export const formatSmsCreditResetDate = (
    iso: string | null | undefined,
    locale: string,
): string | null => {
    if (!iso) return null;
    const at = new Date(iso);
    if (Number.isNaN(at.getTime())) return null;
    const date = at.toLocaleDateString(locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: SMS_CREDIT_RESET_TIME_ZONE,
    });
    return `${date} (ET)`;
};
